import { render, staticRenderFns } from "./register.vue?vue&type=template&id=1a745e98&scoped=true&"
import script from "./register.vue?vue&type=script&lang=ts&"
export * from "./register.vue?vue&type=script&lang=ts&"
import style0 from "./register.vue?vue&type=style&index=0&id=1a745e98&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a745e98",
  null
  
)

export default component.exports